import type { Partnership } from "./partnership";

import type { PermissionType } from "@/shared/constants/permissions";

/**
 * User role values
 */
export const UserRole = {
  ADMIN: "admin",
  USER: "user",
  MODERATOR: "moderator",
  GUEST: "guest",
  CLIENT: "client",
  INTERNAL: "internal",
} as const;

/**
 * User role type
 */
export type UserRoleType = typeof UserRole[keyof typeof UserRole];

/**
 * User permissions type
 * Uses centralized PermissionType from @/shared/constants
 */
export type UserPermission = PermissionType;

/**
 * User interface (shape of the /me payload)
 */
export interface User {
  id: string
  email: string
  name: string
  nickname?: string
  avatar?: string
  role: UserRoleType
  permissions: UserPermission[]
  createdAt: string
  updatedAt: string

  // /me partnership fields — optional: older responses may not include them
  mustChangePassword?: boolean
  /** Whether this account may use the MCP server. Separate from an account being active. */
  isMcpEnabled?: boolean
  brandShortNames?: string[]
  communications?: string[]
  partnership?: Partnership
  partnerships?: Partnership[]
  vendorBrandShortNames?: string[]
}
